import React from "react";
import { motion } from "framer-motion";
import { FaSolarPanel, FaCarBattery, FaPlug, FaBolt } from "react-icons/fa";
import { solarPanels, evCharging, offGrid, electrical } from '../assets';

function ServiceSection({ service, index }) {
  const isEven = index % 2 === 0;

  return (
    <div className="min-h-screen flex items-center py-20 snap-start">
      <div className="container mx-auto px-4">
        <div className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-12 items-center`}>
          <motion.div 
            initial={{ opacity: 0, x: isEven ? -100 : 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="flex-1 space-y-6"
          >
            <div className="flex items-center gap-4 mb-8">
              <service.icon className="text-4xl text-primary-600" />
              <h2 className="text-4xl font-bold text-gray-800">
                {service.title}
              </h2>
            </div>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {service.description}
            </p>

          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: isEven ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl 
                          transform hover:scale-[1.02] transition-transform duration-500">
              <div className="absolute inset-0" />
              <img 
                src={service.image}
                alt={service.title}
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

function Services() {
  const services = [
    {
      title: "Solarne elektrane",
      description: `Iskoristite neograničenu snagu sunca za vaš dom ili poslovanje. 
                 Naši stručnjaci dizajniraju i implementiraju solarne sustave po mjeri, 
                 koji ne samo da smanjuju vaše račune za struju, već i doprinose očuvanju okoliša. 
                 Uz najnoviju tehnologiju i profesionalnu ugradnju, vaša investicija u solarnu 
                 energiju počinje se isplaćivati od prvog dana.`,
      icon: FaSolarPanel,
      image: solarPanels
    },
    {
      title: "Punjači za EV",
      description: `Budite dio električne revolucije u transportu. Nudimo širok spektar 
                 rješenja za punjenje električnih vozila - od kućnih instalacija do 
                 naprednih sustava za poslovne prostore. Naši punjači podržavaju sve 
                 vrste električnih vozila, osiguravajući brzo i sigurno punjenje uz 
                 pametno upravljanje potrošnjom.`,
      icon: FaCarBattery,
      image: evCharging
    },
    {
      title: "Off-grid sistemi",
      description: `Ostvarite potpunu energetsku neovisnost s našim off-grid sustavima. 
                 Projektiramo i instaliramo samostalne energetske sustave koji kombiniraju 
                 solarne panele, baterije i pametno upravljanje. Idealno za udaljene 
                 lokacije ili kao backup rješenje, naši sustavi osiguravaju pouzdanu 
                 opskrbu energijom u svim uvjetima.`,
      icon: FaBolt,
      image: offGrid
    },
    {
      title: "Elektro instalacije",
      description: `Pouzdane i sigurne električne instalacije temelj su svakog modernog 
                 objekta. Naš tim certificiranih električara izvodi sve vrste elektroinstalacijskih 
                 radova - od jednostavnih popravaka do kompleksnih instalacija za 
                 cijele objekte. Koristimo najkvalitetnije materijale i najnovije 
                 tehnologije uz strogo poštivanje sigurnosnih standarda.`,
      icon: FaPlug,
      image: electrical
    }
  ];

  return (
    <div className="relative bg-gradient-to-b from-primary-50 to-white overflow-hidden 
                    snap-y snap-mandatory">
      {/* Background Decorations */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute -top-1/4 -right-1/4 w-1/2 h-1/2 bg-primary-100/30 rounded-full blur-3xl" />
        <div className="absolute -bottom-1/4 -left-1/4 w-1/2 h-1/2 bg-primary-200/20 rounded-full blur-3xl" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-3xl mx-auto pt-20 px-4 relative space-y-6"
      >

        <motion.h1
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-5xl font-bold bg-gradient-to-r from-primary-600 
                     to-primary-800 bg-clip-text text-transparent"
        >
          Inovativna tehnologija
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-lg text-gray-600 max-w-2xl mx-auto"
        >
          Pružamo napredna energetska rješenja koja kombiniraju održivost, 
          učinkovitost i inovaciju za bolju budućnost.
        </motion.p>
      </motion.div>

      {services.map((service, index) => (
        <ServiceSection key={index} service={service} index={index} />
      ))}
    </div>
  );
}

export default Services;